import { styled } from '@mui/material';

export const Container = styled('div')(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  alignItems: 'center',
  justifyContent: 'center',
}));
